import { LayingType } from 'pages/common/components/LayingTypeField/const';
import { Inputs } from '../types';

export const getDefaultValues = ({
  hasDoors,
  hasThickness,
  dimensionState,
}: {
  hasDoors: boolean;
  hasThickness: boolean;
  dimensionState: Partial<Inputs>;
}) => ({
  ...(hasDoors && { doors: '1' }),
  ...(hasThickness && { thickness: LayingType.horizontal }),
  ...{
    width: '0',
    length: '0',
    layerThickness: '0',
    area: '0',
    height: '0',
  },
  ...dimensionState,
});
